import React, { memo } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { string, number } from 'prop-types'

const Svg = styled.svg`
	&:hover {
		circle {
			fill: ${({ hoverBackgroundColor }) => (hoverBackgroundColor ? hoverBackgroundColor : 'transparent')};
		}
		path {
			fill: ${({ hoverColor }) => hoverColor};
			stroke: ${({ hoverColor }) => hoverColor};
		}
	}
`

export const Instagram = memo(({ height = 30, variant = 'primary', width = 30 }) => {
	const {
		colors,
		socialProfileSvgs: { inverse, neutral, primary },
	} = useTheme()
	let backgroundColor = 'transparent'
	let fillColor = colors.secondary
	let hoverBackgroundColor = 'transparent'
	let hoverColor = colors.tertiary

	switch (variant) {
		case 'neutral':
			backgroundColor = neutral.backgroundColor
			fillColor = neutral.fillColor
			hoverBackgroundColor = neutral.hoverBackgroundColor
			hoverColor = neutral.hoverFillColor
			break
		case 'inverse':
			fillColor = inverse.fillColor
			hoverColor = inverse.hoverFillColor
			break
		case 'primary':
		default:
			fillColor = primary.fillColor
			hoverColor = primary.hoverFillColor
			break
	}
	return (
		<Svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 26.1 26.1"
			style={{ enableBackground: 'new 0 0 26.1 26.1' }}
			xmlSpace="preserve"
			hoverColor={hoverColor}
			hoverBackgroundColor={hoverBackgroundColor}
		>
			<circle id="top" cx={13.1} cy={13.1} r={13.1} fill={backgroundColor} />
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M13,26.1c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13C26,20.2,20.2,26,13,26.1z M13,1C6.4,1,1,6.4,1,13
                s5.4,12,12,12s12-5.4,12-12S19.6,1,13,1z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M15.7,20.1h-5.4c-2.4,0-4.3-1.9-4.3-4.3v-5.4C6,7.9,7.9,6,10.3,6h5.4c2.4,0,4.3,1.9,4.3,4.3v5.4
                C20.1,18.1,18.1,20.1,15.7,20.1z M10.3,7C8.5,7,7,8.4,7,10.3v0.1v5.4c0,1.8,1.5,3.3,3.3,3.3h5.4c1.8,0,3.3-1.5,3.3-3.3v-5.4
                C19,8.5,17.6,7,15.7,7l0,0H10.3z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M13,16.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5C16.6,14.9,15,16.5,13,16.5
                C13,16.6,13,16.6,13,16.5z M13,10.5c-1.4,0-2.5,1.1-2.4,2.5c0,1.4,1.1,2.5,2.5,2.4c1.4,0,2.5-1.1,2.4-2.5
                C15.5,11.6,14.4,10.5,13,10.5L13,10.5z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M16.9,10.4c-0.6,0-1.1-0.5-1.2-1.1c0-0.6,0.5-1.1,1.1-1.2c0.6,0,1.1,0.5,1.2,1.1l0,0
                C18,9.9,17.5,10.4,16.9,10.4z M16.9,9.2C16.9,9.2,16.8,9.3,16.9,9.2L16.9,9.2C16.8,9.4,17,9.4,16.9,9.2C17,9.3,16.9,9.2,16.9,9.2
                L16.9,9.2z"
			/>
		</Svg>
	)
})

Instagram.propTypes = {
	color: string,
	height: number,
	width: number,
}
